import React from "react";
import { Link } from "react-router-dom";

export default function AdminNotificationsOverview() {
  const containerStyles = "mb-[30px] bg-white rounded-xl shadow-md blur-2 text-opacity-15 spread-0";

  return (
    <div className={containerStyles}>
      <section className="p-6">
        <h2 className="text-xl font-bold mb-2">Manage your notifications</h2>
        <Link className="block text-blue-600 hover:text-blue-800" to="/settings">
          View Settings
        </Link>
      </section>
    </div>
  );
}
